import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useMemo } from 'react';

const OtrosDestinos = ({ lang, destinos, ruta, destino }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";


    var titulofoto = "";
    var textofoto = "";

    if (destino.id == 36) {
        titulofoto = t("Elige el mar, nosotros hacemos el resto")
        textofoto = t("Cuéntanos cómo sueñas tu viaje. Nuestros expertos seleccionarán las mejores rutas y barcos según tu estilo. Atención personalizada, sin compromiso.")
    }
    else if (destino.id == 40) {
        titulofoto = t("Convierte tu idea en un itinerario perfecto")
        textofoto = t("Cuéntanos cómo sueñas tu viaje. Nuestros expertos seleccionarán las mejores rutas y barcos según tu estilo. Atención personalizada, sin compromiso.")
    }
    else if (destino.id == 32) {
        titulofoto = t("Elige el mar, nosotros hacemos el resto")
        textofoto = t("Cuéntanos cómo sueñas tu viaje. Nuestros expertos seleccionarán las mejores rutas y barcos según tu estilo. Atención personalizada, sin compromiso.")
    }
    else if (destino.id == 43) {
        titulofoto = t("¿No sabes por dónde empezar?")
        textofoto = t("Cuéntanos cómo sueñas tu viaje. Nuestros expertos seleccionarán las mejores rutas y barcos según tu estilo. Atención personalizada, sin compromiso.")
    }
    else if (destino.id == 44) {
        titulofoto = t("Porque cada viajero es único, y cada ruta también")
        textofoto = t("Cuéntanos cómo sueñas tu viaje. Nuestros expertos seleccionarán las mejores rutas y barcos según tu estilo. Atención personalizada, sin compromiso")
    }
    else if (destino.id == 48) {
        titulofoto = t("Elige el mar, nosotros hacemos el resto")
        textofoto = t("Cuéntanos cómo sueñas tu viaje. Nuestros expertos seleccionarán las mejores rutas y barcos según tu estilo. Atención personalizada, sin compromiso")
    }
    else if (destino.id == 47) {
        titulofoto = t("Elige el mar, nosotros hacemos el resto")
        textofoto = t("Cuéntanos cómo sueñas tu viaje. Nuestros expertos seleccionarán las mejores rutas y barcos según tu estilo. Atención personalizada, sin compromiso")
    }
    else if (destino.id == 50) {
        titulofoto = t("Una forma distinta de recorrer Europa")
        textofoto = t("Vive tu mejor experiencia a bordo Crucero Boutique. Cada detalle está pensado para viajar con estilo y tranquilidad.")
    }
    else if (destino.id == 52) {
        titulofoto = t("Elige navegar, nosotros hacemos el resto")
        textofoto = t("Cuéntanos cómo sueñas tu viaje. Nuestros expertos seleccionarán las mejores rutas y barcos según tu estilo. Atención personalizada, sin compromiso")
    }
    else {
        titulofoto = t("Elige el mar, nosotros hacemos el resto")
        textofoto = t("Cuéntanos cómo sueñas tu viaje. Nuestros expertos seleccionarán las mejores rutas y barcos según tu estilo. Atención personalizada, sin compromiso")
    }


    const itineraries = {
        32: "Un laberinto de islas bañadas por aguas azules, donde historia y mitología se encuentran en cada travesía.",
        43: "Entre bahías turquesas y bazares vibrantes, la Costa Turquesa revela un viaje lleno de exotismo y tradición.",
        48: "Un paraíso mediterráneo de calas escondidas y paisajes dorados, creado para quienes buscan elegancia y calma.",
        44: "Un refugio exclusivo donde el horizonte y el agua cristalina se funden en una experiencia privada incomparable",
        40: "Entre puertos coloridos y costas legendarias, cada escala revela el encanto eterno del Mediterráneo",
        36: "Un mosaico de islas y calas secretas, diseñado para quienes buscan la perfección en cada travesía",
        54: "Un mar sereno salpicado de ciudades históricas y calas escondidas, donde cada ruta invita a descubrir su esencia más pura",
        51: "Un paraíso de aguas turquesa y arenas infinitas, donde cada travesía se convierte en una experiencia de libertad absoluta",
        42: "Dos islas de carácter indomable, entre acantilados salvajes y playas cristalinas que definen la belleza mediterránea",
        50: "Un viaje fluvial entre capitales imperiales y paisajes cambiantes, donde la historia fluye al ritmo del río",
        52: "Un recorrido milenario entre templos y horizontes dorados, donde cada travesía revela el misterio de una civilización eterna",
        53: "Una ruta que enlaza culturas y paisajes a lo largo de la costa ibérica, donde cada escala descubre una nueva forma de vivir el mar"
    };

    const defaultText = "Cuéntanos cómo sueñas tu viaje. Nuestros expertos seleccionarán las mejores rutas y barcos según tu estilo. Atención personalizada, sin compromiso";

    var losdestinos = [];
    for (var j = 0; j < destinos.length; j++) {
        var undestino = destinos[j];
        (undestino.id != 47) ? losdestinos.push(undestino) : "";
    }

    // Detectar si es móvil
    const [isMobile, setIsMobile] = useState(false);

    const [itemsPerPage, setItemsPerPage] = useState(3);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);
            setItemsPerPage(mobile ? 1 : 3);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Crear páginas usando useMemo para recalcular cuando cambie itemsPerPage
    const pages = useMemo(() => {
        const totalPages = Math.ceil(losdestinos.length / itemsPerPage);
        return Array.from({ length: totalPages }, (_, i) =>
            losdestinos.slice(i * itemsPerPage, (i + 1) * itemsPerPage)
        );
    }, [losdestinos, itemsPerPage]);

    const totalPages = pages.length;

    // Estado para controlar el índice de inicio (0 para los primeros 3, 3 para los siguientes 3)
    const [currentPage, setCurrentPage] = useState(0);

    // Función para ir a la siguiente página (derecha)
    const next = (e) => {
        e.preventDefault();
        console.log("next");
        if (currentPage < totalPages - 1) { // Solo hay 2 páginas (0 y 1)
            setCurrentPage(currentPage + 1);
        }
        else {
            setCurrentPage(0);
        }
    };
    // Función para ir a la página anterior (izquierda)
    const prev = (e) => {
        e.preventDefault();
        console.log("prev");
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
        else {
            setCurrentPage(totalPages - 1);
        }
    };

    var seccion = 10;

    if (destino.id == 36) {
        seccion = 10;
    }
    else if (destino.id == 43) {
        seccion = 12;
    }
    else if (destino.id == 40) {
        seccion = 15;;
    }
    else if (destino.id == 32) {
        seccion = 12;
    }
    else if (destino.id == 44) {
        seccion = 8;
    }
    else if (destino.id == 48) {
        seccion = 5;
    }
    else if (destino.id == 47) {
        seccion = 6;
    }
    else if (destino.id < 50) {
        seccion = 10;
    }
    else seccion = 10;

    return (
        <>
            <section className={"u-clearfix u-section-" + seccion} id="block-10">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-sheet-1">
                    <h2 className="u-align-center u-text u-text-body-color u-text-default-lg u-text-default-md u-text-default-sm u-text-default-xl u-text-1" data-animation-name="customAnimationIn" data-animation-duration="1500" data-animation-out="0">{t("Otros destinos")} </h2>
                    <p className="u-align-center u-text u-text-body-color u-text-2" data-animation-name="customAnimationIn" data-animation-duration="1500" data-animation-delay="250" data-animation-out="0"> {t("Más destinos de ensueño para tu alquiler de barcos y vacaciones en el mar")}</p>
                </div>
            </section>
            <section className={"u-clearfix u-custom-color-5 u-section-" + (seccion + 1)} id="sec-b24e">
                <div className="u-clearfix u-sheet u-valign-middle u-sheet-1">
                    <div className="u-expanded-width u-layout-horizontal u-list u-list-1" style={{ overflow: 'hidden', width: '100%' }}>
                        <div className="u-repeater u-repeater-1"
                            style={{
                                display: 'flex',
                                transform: `translateX(-${currentPage * (100 / totalPages)}%)`,
                                transition: 'transform 0.5s ease',
                                width: `${(totalPages) * 100}%`
                            }}
                        >
                            {pages.map((page, pageIndex) => (
                                <div key={pageIndex} style={{ width: '100%', display: 'flex', gap: isMobile ? '0' : '28px', marginLeft: isMobile ? "20px" : "0" }} >
                                    {page.map((item, itemIndex) => (
                                        <div key={item.id} className={`u-container-style u-list-item u-radius u-repeater-item u-shape-round u-white u-list-item-${pageIndex * itemsPerPage + itemIndex + 1}`} style={{ flex: 1 }}>
                                            <div className={`u-container-layout u-similar-container u-valign-bottom-lg u-valign-bottom-md u-valign-bottom-sm u-valign-bottom-xs u-container-layout-${pageIndex * itemsPerPage + itemIndex + 1}`}>
                                                <img className="u-expanded-width u-image u-image-round u-radius u-image-1" src={`/images/web/onboard2/dest${item.id}-2.jpg`} alt="" data-image-width="1414" data-image-height="2000" />
                                                <h6 className="u-align-center u-text u-text-black u-text-default u-text-1">{item.elnombre.toUpperCase()}</h6>
                                                <p className="u-align-center u-text u-text-default u-text-grey-50 u-text-2">
                                                    {t(itineraries[item.id] || defaultText)}
                                                </p>
                                                <a className="u-active-none u-align-center-md u-align-center-sm u-align-center-xs u-btn u-button-link u-button-style u-hover-feature u-hover-none u-none u-text-hover-grey-50 u-btn-1" href={"/" + preidioma + t("contacto")} style={{ marginLeft: "auto", marginRight: "auto" }}>{t("TE ASESORAMOS")}</a>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                        <a className="u-absolute-vcenter u-custom-color-5 u-gallery-nav u-gallery-nav-prev u-icon-circle u-opacity u-opacity-70 u-spacing-10 u-text-hover-grey-10 u-text-white u-gallery-nav-1" href="#" role="button" onClick={(e) => prev(e)}>
                            <span aria-hidden="true">
                                <svg viewBox="0 0 451.847 451.847">
                                    <path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"></path>
                                </svg>
                            </span>
                            <span className="sr-only">
                                <svg viewBox="0 0 451.847 451.847">
                                    <path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"></path>
                                </svg>
                            </span>
                        </a>
                        <a className="u-absolute-vcenter u-custom-color-5 u-gallery-nav u-gallery-nav-next u-icon-circle u-opacity u-opacity-70 u-spacing-10 u-text-hover-grey-10 u-text-white u-gallery-nav-2" href="#" role="button" onClick={(e) => next(e)}>
                            <span aria-hidden="true">
                                <svg viewBox="0 0 451.846 451.847">
                                    <path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"></path>
                                </svg>
                            </span>
                            <span className="sr-only">
                                <svg viewBox="0 0 451.846 451.847">
                                    <path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"></path>
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>
            </section>
            <section className={"u-clearfix u-section-" + (seccion + 2)} id="block-11">
                <div className="u-clearfix u-sheet u-sheet-1"></div>
            </section>
            <section className={"u-clearfix u-image u-shading u-section-" + (seccion + 3)} id="block-1" data-image-width="1920" data-image-height="1080" style={{
                backgroundImage: (destino.imagenes.length > 2)
                    ? `linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${ruta}/destinos/${destino.id}/${destino.imagenes[2].imagen})`
                    : `linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(/images/web/bedloop-nofoto.png)`
            }}>
                <div className="u-clearfix u-sheet u-sheet-1">
                    <h3 className="u-custom-font u-text u-text-font u-text-white u-text-1 ">{titulofoto}</h3>
                    <p className={`u-custom-font u-font-montserrat u-text u-text-white u-text-2 ${(destino.id == 40) ? "u-align-center-xs u-align-right-lg u-align-right-md u-align-right-sm u-align-right-xl" : ""}`}> {textofoto}</p>
                    <a href={"/" + preidioma + t("contacto")} className="u-border-2 u-border-custom-color-5 u-border-hover-custom-color-5 u-btn u-btn-round u-button-style u-hover-grey-5 u-radius u-text-custom-color-5 u-white u-btn-1">📩 {t("​Solicitar presupuesto")} </a>
                </div>
            </section>

        </>
    )
}
export default OtrosDestinos;
